<template>
  <div :style="myStyle.mainBackground">
    <div class="bigTitle">园区用电管理系统</div>
    <div style="height: 10%; width: 100%; position: absolute; top: 10px">
      <p style="margin: 0px; text-align: right">
        <span
          @click="exitBigScreen"
          style="position: relative; top: 15px; right: 20px"
          class="exitBigScreen icon iconfont"
        >
          &#xe603;
        </span>
      </p>
    </div>
    <div style="height: 90%; width: 98%; padding: 1%; margin: 0 auto">
      <div class="first_line">
        <!-- 用电概况 -->
        <div
          class="ElectricityConsumption first_lineBox"
          style="height: 17.125rem"
        >
          <!-- 标题 -->
          <h3>用电概况</h3>
          <!-- 数据源头 -->
          <p class="pth">
            <span>用户</span>
            <span>电表</span>
            <span>月份</span>
            <span>金额</span>
            <span>余额</span>
            <span>度数</span>
            <span>付费类型</span>
            <span>催缴次数</span>
          </p>
          <!-- 滚动区 -->
          <div class="roll">
            <vue-seamless-scroll
              :data="detailList"
              class="seamless-warp"
              :class-option="defaultOption"
            >
              <ul>
                <li
                  class="item"
                  v-for="(item, index) in detailList"
                  :key="index"
                >
                  <p class="rollData">
                    <span>{{ item.lesseeName }}</span>
                    <span>{{ item.meter }}</span>
                    <span>{{ item.month }}</span>
                    <span>{{ item.money }}</span>
                    <span>{{ item.balance }}</span>
                    <span>{{ item.electricUsage }}</span>
                    <span>{{ item.payType }}</span>
                    <span>{{ item.remindTimes }}</span>
                  </p>
                </li>
              </ul>
            </vue-seamless-scroll>
          </div>
          <p class="pth">
            <span>合计</span>
            <span></span>
            <span></span>
            <span>{{ total.money }}</span>
            <span>{{ total.balance }}</span>
            <span></span>
            <span></span>
            <span></span>
          </p>
        </div>
        <!-- 报警信息 -->
        <div class="warningInfo first_lineBox">
          <h3>报警信息</h3>
          <!-- 数据源头 -->
          <p class="pth">
            <span>用户</span>
            <span>告警余额</span>
            <span>告警时间</span>
            <span>事件序号</span>
          </p>
          <!-- 滚动区 -->
          <div class="roll">
            <vue-seamless-scroll
              :data="warningTableData"
              class="seamless-warp"
              :class-option="defaultOption"
            >
              <ul>
                <li
                  class="item"
                  v-for="(item, index) in warningTableData"
                  :key="index"
                >
                  <p class="warningRollData">
                    <span>{{ item.lesseeName }}</span>
                    <span>{{ item.balance }}</span>
                    <span>{{ item.eventTime }}</span>
                    <span>{{ item.eventSno }}</span>
                  </p>
                </li>
              </ul>
            </vue-seamless-scroll>
          </div>

          <!-- 表格 -->
          <!-- <el-table :data="warningTableData" class="warningTable" :header-row-style="{background:'transparent'}"
                    >
                    <el-table-column prop="lesseeName" label="用户" >    </el-table-column>
                    <el-table-column prop="balance" label="告警余额">    </el-table-column>
                    <el-table-column prop="eventTime" label="告警时间">    </el-table-column>
                    <el-table-column prop="eventSno" label="事件序号">    </el-table-column>
                  </el-table> -->
        </div>
        <!-- 设备运行概况 -->
        <div class="EquipmentOperation first_lineBox">
          <!-- 上半部分 -->
          <div class="EquipmentOperation_main">
            <!-- 上半部分左侧 -->
            <div class="EquipmentOperation_left clearfix">
              <h3>设备运行概况</h3>
              <div class="EquipmentOperation_data">
                <div class="TotalEquipment">
                  设备总数：<span style="color: #00ffff">{{
                    deviceRunList.total
                  }}</span>
                </div>

                <div class="running">
                  运行设备：<span style="color: #00ffff">{{
                    deviceRunList.run
                  }}</span>
                </div>

                <div class="SwitchOff">
                  拉闸设备：<span style="color: #ff3300">{{
                    deviceRunList.stop
                  }}</span>
                </div>
                <div class="free">
                  空闲设备：<span style="color: #00ff00">{{
                    deviceRunList.unused
                  }}</span>
                </div>
              </div>
            </div>
            <!-- 上半部分中间 -->
            <!-- 上半部分右侧 -->
            <div class="EquipmentOperation_right">
              <span>运行概况</span>
              <!-- 饼图 -->
              <div class="PieChart" id="EquipmentOperationPieChartBig"></div>
            </div>
          </div>
          <!-- 下半部分 -->
          <div class="EquipmentOperation_footer">
            <div>
              设备不正常运行率：<span style="color: #ff3300"
                >{{ deviceRunList.abnormalRate }}%</span
              >
            </div>
            <div>
              设备空闲率：<span style="color: #00ff00"
                >{{ deviceRunList.unusedRate }} %</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="second_line">
        <!-- 用能统计 -->
        <div class="EnergyConsumptionStatistics">
          <!-- 第一行 -->
          <h3 class="title">用能统计</h3>
          <!-- 图表 -->
          <div class="LineChart" id="EnergyConsumptionStatisticsChart"></div>
        </div>
        <!-- 用能排行 -->
        <div class="EnergyConsumptionRanking">
          <!-- 第一行 -->
          <h3 class="title" style="display: inline-block">用能排行</h3>
          <div
            class="btns"
            style="display: inline-block; float: right; margin: 10px"
          >
            <el-button
              type="primary"
              size="small"
              @click="setType(3)"
              :plain="plainBool3"
              >日</el-button
            >
            <el-button
              type="primary"
              size="small"
              @click="setType(2)"
              :plain="plainBool2"
              >月</el-button
            >
            <el-button
              type="primary"
              size="small"
              @click="setType(1)"
              :plain="plainBool1"
              >年</el-button
            >
          </div>
          <!-- 图表 -->
          <div class="Histogram" id="EnergyConsumptionHistogram"></div>
        </div>
      </div>
      <div class="map" v-if="false"></div>
      <!-- 底层地图 -->
      <div class="amap-wrapper">
        <div id="cesiumContainer">
          <!-- <button type="button" @click="initialPerspective">回到默认</button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';

// import Axios from "axios";
import vueSeamlessScroll from 'vue-seamless-scroll';
// import { getAlarmInfo } from '../api/bigScreen';

import {
  getLesseeArrearsList,
  getDeviceRunState,
  getEnergyUsageStatistics,
  getEnergyLossRank,
} from '../api/homepage/homepage';
import electricConstant from '../constant/ElectricConstant.js';
// import {getToken} from "../untils/func";

export default {
  props: ['bigScreenFlag'],

  data() {
    return {
      type: electricConstant.day,
      total: {},
      detailList: [],
      deviceRunList: {},
      pieChartData: [],
      warningTableData: [],
      usageSum: [],
      energyRankData: [],
      plainBool1: true,
      plainBool2: true,
      plainBool3: false,
      myChart1: '',
      myChart2: '',
      myChart3: '',
      // 全屏样式
      myStyle: {
        mainBackground: {
          // backgroundImage: 'url(' + require('../assets/bigscreen.png') + ')',
          // backgroundRepeat: 'no-repeat',
          // backgroundSize: '100% 100%',
          width: '100%',
          height: '100%',
          position: 'absolute',
          top: '0px',
          left: '0px',
          right: '0px',
          bottom: '0px',
          overflow: 'hidden',
          color: 'white',
          fontSize: '1em',
        },
      },
    };
  },

  created() {},
  computed: {
    defaultOption() {
      return {
        step: 0.5,
      };
    },
  },
  watch: {
    bigScreenFlag() {
      if (this.bigScreenFlag) {
        this.getUseElectricData(); // 获取用电概况数据
        this.getEquipRunData(); // 获取设备运行概况
        this.getEnergyUsageSumData(); //获取用能统计
        this.getEnergyRankData(); //获取用能排行
        this.getAlarmInfoData(); //获取报警信息
        console.log(this.bigScreenFlag);
        this.cesium();
      } else {
        // console.log(this.bigScreenFlag)
        this.myChart1.dispose();
        this.myChart2.dispose();
        this.myChart3.dispose();
        this.myChart1 = '';
        this.myChart2 = '';
        this.myChart3 = '';
        window.viewer.destroy ();
        window.viewer = '';
        console.log(this.bigScreenFlag);
      }
    },
  },

  methods: {

    // 设置年月日
    setType(type) {
      if (type == 1) {
        this.type = electricConstant.year;
        this.plainBool1 = false;
        this.plainBool2 = true;
        this.plainBool3 = true;
      } else if (type == 2) {
        this.type = electricConstant.month;
        this.plainBool2 = false;
        this.plainBool3 = true;
        this.plainBool1 = true;
      } else if (type == 3) {
        this.type = electricConstant.day;
        this.plainBool3 = false;
        this.plainBool1 = true;
        this.plainBool2 = true;
      }
      this.getEnergyRankData(); //获取用能排行
    },
    // 获取报警信息 数据
    async getAlarmInfoData() {
      // const resultWarning = await getAlarmInfo().then();
      // this.warningTableData = resultWarning.data;
      this.warningTableData = [
        {
          lesseeName:'用户1',
          balance:'2',
          eventTime:'2021-11-27 11:20:59',
          eventSno:'1111'
        }
      ];
      // console.log(resultWarning);
    },
    // 获取用电概况数据
    async getUseElectricData() {
      const result1 = await getLesseeArrearsList().then();
      this.total = result1.data.total;

      // this.detailList = result1.data.detail;
      this.detailList = [{
        lesseeName:'用户1',
        meter:'电表1',
        month:'11',
        money:'20',
        balance:'',
        electricUsage:'112.4',
        payType:'后付费',
        remindTimes:'1',
      }]
    },
    // 获取设备运行概况
    async getEquipRunData() {
      const result2 = await getDeviceRunState().then();
      this.deviceRunList = result2.data;
      this.pieChartData = result2.data.pieChartData;
      this.equipmentOperation();
    },
    // 获取用能统计
    async getEnergyUsageSumData() {
      const result3 = await getEnergyUsageStatistics().then();
      this.usageSum = result3.data;
      this.energyConsumptionStatistics();
    },
    // 获取用能排行
    async getEnergyRankData() {
      const param = { type: this.type };
      const result4 = await getEnergyLossRank(param).then();
      this.energyRankData = result4.data;
      this.energyConsumptionRanking();
    },
    // 饼图1
    equipmentOperation() {
      if (this.myChart1 == '') {
        this.myChart1 = echarts.init(
          document.getElementById('EquipmentOperationPieChartBig')
        );
      }
      const option = {
        tooltip: {
          trigger: 'item',
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center',
              textStyle: {
                color: 'rgba(255,255,255)',
              },
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '20',
                fontWeight: 'bold',
              },
            },
            labelLine: {
              show: false,
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  //定义圆分类的颜色
                  //自定义颜色
                  var colorList = ['#87CEFA ', '#657de6', '#39b95f'];
                  return colorList[params.dataIndex];
                },
              },
            },
            data: this.pieChartData,
          },
        ],
      };
      this.myChart1.setOption(option);
      this.myChart1.resize();
      window.addEventListener('resize', () => {
        this.myChart1.resize();
      });
    },
    // 折线图2
    energyConsumptionStatistics() {
      if (this.myChart2 == '') {
        this.myChart2 = echarts.init(
          document.getElementById('EnergyConsumptionStatisticsChart')
        );
      }
      const option = {
        // title: {
        // 	text: '折线图堆叠'
        // },
        color: ['#9D2933', '#2081ad', '#808bc6'],
        tooltip: {
          trigger: 'axis',
        },
        textStyle: {
          color: 'rgba(255,255,255,0.8)',
        },
        lineStyle: {
          normal: {
            color: '#9D2933',
            width: 3,
          },
        },
        legend: {
          data: this.usageSum.legendDate,
          textStyle: {
            color: {
              type: 'inherit',
            },
          },
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.usageSum.xData,
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value} kW·h',
          },
        },
        series: [
          {
            name: this.usageSum.yName[0],
            type: 'line',
            data: this.usageSum.yData[0],
          },
          {
            name: this.usageSum.yName[1],
            type: 'line',
            data: this.usageSum.yData[1],
          },
        ],
      };
      this.myChart2.setOption(option);
      this.myChart2.resize();
      window.addEventListener('resize', () => {
        this.myChart2.resize();
      });
    },
    // 柱形图 3
    energyConsumptionRanking() {
      if (this.myChart3 == '') {
        this.myChart3 = echarts.init(
          document.getElementById('EnergyConsumptionHistogram')
        );
      }
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        textStyle: {
          color: 'rgba(255,255,255,0.8)',
        },

        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: this.energyRankData.xData,
            axisTick: {
              alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              formatter: '{value} kW·h',
            },
          },
        ],
        series: [
          {
            name: '用电度数',
            type: 'bar',
            barWidth: '60%',
            data: this.energyRankData.yData,
          },
        ],
      };
      this.myChart3.setOption(option);
      this.myChart3.resize();
      window.addEventListener('resize', () => {
        this.myChart3.resize();
      });
    },

    exitBigScreen() {
      this.$emit('exitBigScreen');
    },
  },

  mounted() {
    // window.addEventListener("resize", () => {
    //       this.myChart1.resize();
    //       this.myChart2.resize();
    //       this.myChart3.resize();
    // });
    // this.adaption()
    // if (this.bigScreenFlag){
    //
    // }
  },

  components: {
    vueSeamlessScroll,
  },
};
</script>

<style scoped lang="scss">
@font-face {
  font-family: huaKangCircleFont;
  src: url(../assets/华康圆体.ttf);
}

@font-face {
  font-family: siYuanBlackFont;
  src: url(../assets/思源黑体.otf);
}

@font-face {
  font-family: simpleFont;
  src: url(../assets/简体字.ttf);
}
h3 {
  color: #0077b3;
  font-size: 1.2rem;
}

.bigTitle {
  font-size: 50px;
  font-family: simpleFont;
  // src: url(../assets/思源黑体.otf);
  text-align: center;
  // margin-top: 1%;
  letter-spacing: 1rem;
  background: url('../assets/bigscreen_head.png');
  height: 65px;
}

.exitBigScreen {
  display: inline-block;
  width: 3rem;
  height: 3rem;
  line-height: 3rem;
  // background-color: #0044cc;
  text-align: center;
  font-size: 1.5rem;
  opacity: 0.9;
  cursor: pointer;
  color: white;
}

ul {
  padding: 0;
}

li {
  list-style: none;
}

h3,
h5 {
  margin: 0;
}

.first_line {
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: 999;
}

.first_lineBox {
  height: 40%;
  background-color: rgba(6, 64, 102, 0.6);
}

.ElectricityConsumption:after,
.EquipmentOperation:after,
.EnergyConsumptionStatistics:after,
.EnergyConsumptionRanking:after,
.warningInfo:after {
  border-right: 1px solid #0258f0;
  border-bottom: 1px solid #0258f0;
  right: -1px;
  bottom: -1px;
  position: absolute;
  content: '';
  width: 20px;
  height: 30px;
  z-index: 999;
}

.ElectricityConsumption:before,
.EquipmentOperation:before,
.EnergyConsumptionStatistics:before,
.EnergyConsumptionRanking:before,
.warningInfo:before {
  border-left: 1px solid #0258f0;
  border-top: 1px solid #0258f0;
  left: -1px;
  top: -1px;
  position: absolute;
  content: '';
  width: 20px;
  height: 30px;
}

.warningInfo {
  flex: 1;
  padding: 1%;
  margin: 0 1%;
  position: relative;
  height: 100%;
  h3 {
    color: #0077b3;
    margin-bottom: 5px;
  }
  .pth {
    font-size: 0;
    padding: 0.2rem 0;
    span {
      display: inline-block;
      font-size: 1rem;
      text-align: center;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .roll {
    height: 13.2rem;
    overflow: hidden;
    position: relative;
    ul {
      li {
        p {
          margin: 0;
          span {
            display: inline-block;
            line-height: 300%;
            font-size: 1rem;
            text-align: center;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
  .warningRollData span:nth-child(1),
  .pth span:nth-child(1) {
    width: 15%;
    max-width: 15%;
  }
  .warningRollData span:nth-child(2),
  .pth span:nth-child(2) {
    width: 25%;
    max-width: 20%;
  }
  .warningRollData span:nth-child(3),
  .pth span:nth-child(3) {
    width: 30%;
    max-width: 30%;
  }
  .warningRollData span:nth-child(4),
  .pth span:nth-child(4) {
    width: 30%;
    max-width: 35%;
  }
  .warningRollData {
    span:nth-child(1) {
      color: #99ccff;
    }
    span:nth-child(2) {
      color: #66ccff;
    }
    span:nth-child(3) {
      color: #33ccff;
    }
    span:nth-child(4) {
      color: #00ccff;
    }
  }
}
.roll ul li:nth-of-type(even) {
  background-color: #26396c;
}

.ElectricityConsumption {
  width: 30%;
  padding: 1%;
  position: relative;
  h3 {
    color: #0077b3;
  }

  #title {
    margin-left: 40%;
    width: 15%;
    display: inline-block;
    max-width: 15%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  #menoy {
    margin-left: 0.5%;
    width: 15%;
    display: inline-block;
    max-width: 15%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .pth {
    font-size: 0;
    padding: 0.2rem 0;

    span {
      display: inline-block;
      font-size: 1rem;
      text-align: center;
    }
  }

  .roll {
    height: 11rem;
    overflow: hidden;

    ul {
      li {
        p {
          margin: 0;

          span {
            display: inline-block;
            line-height: 300%;
            font-size: 1rem;
            text-align: center;
          }
        }
      }
    }
  }
}

.rollData span:nth-child(1),
.pth span:nth-child(1) {
  width: 12%;
  max-width: 12%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.rollData span:nth-child(2),
.pth span:nth-child(2) {
  width: 16%;
  max-width: 16%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.rollData span:nth-child(3),
.pth span:nth-child(3) {
  width: 12%;
  max-width: 12%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.rollData span:nth-child(4),
.pth span:nth-child(4) {
  width: 14%;
  max-width: 14%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.rollData span:nth-child(5),
.pth span:nth-child(5) {
  width: 14%;
  max-width: 14%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.rollData span:nth-child(6),
.pth span:nth-child(6) {
  width: 10%;
  max-width: 10%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.rollData span:nth-child(7),
.pth span:nth-child(7) {
  width: 11%;
  max-width: 11%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.rollData span:nth-child(8),
.pth span:nth-child(8) {
  width: 11%;
  max-width: 11%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.rollData span:nth-child(1) {
  color: #0088cc;
}

.rollData span:nth-child(2) {
  color: #0099e6;
}

.rollData span:nth-child(3) {
  color: #00aaff;
}

.rollData span:nth-child(4) {
  color: #1ab3ff;
}

.rollData span:nth-child(5) {
  color: #33bbff;
}

.rollData span:nth-child(6) {
  color: #4dc4ff;
}

.rollData span:nth-child(7) {
  color: #66ccff;
}

.rollData span:nth-child(8) {
  color: #80d5ff;
}

.EquipmentOperation {
  width: 28%;
  padding: 1%;
  position: relative;

  .EquipmentOperation_main {
    display: flex;
    border-bottom: 1px solid #1ab3ff;
  }

  .EquipmentOperation_left {
    width: 40%;

    .EquipmentOperation_data {
      line-height: 250%;
      font-size: 1rem;
      div {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .EquipmentOperation_right {
    width: 40%;
    margin-left: 10%;
    span {
      font-size: 1rem;
    }
    .PieChart {
      width: 100%;
      height: 100%;
    }
  }

  .EquipmentOperation_footer {
    line-height: 195%;
    font-size: 1rem;
    div {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
}

.second_line {
  margin-top: 2%;
  display: flex;
  justify-content: space-between;
  z-index: 9999;
}

.EnergyConsumptionStatistics {
  width: 32%;
  background-color: rgba(6, 64, 102, 0.6);
  position: relative;
z-index: 999;
  .title {
    border-bottom: 1px solid #1ab3ff;
    padding: 2%;
    color: #0077b3;
  }

  .LineChart {
    height: 15rem;
    width: 100%;
  }
}

.EnergyConsumptionRanking {
  width: 30%;
  height: 100%;
  background-color: rgba(6, 64, 102, 0.6);
  position: relative;
z-index: 999;


  .title {
    border-bottom: 1px solid #1ab3ff;
    padding: 2%;
    color: #0077b3;
  }

  .Histogram {
    height: 15rem;
  }
}

.map {
  width: 35%;
  height: 80%;
  background-color: rgba(6, 64, 102, 0.6);
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-47%, -48%);
}
.amap-wrapper {
  width: 100%;
  height: 92.4%;
  position: fixed;
  top: 65px;
  left: 0;
  z-index: 1;
  opacity: 0.8;
}
#cesiumContainer {
  height: 100%;
  width: 100%;
}
</style>
